// import Vue from "vue";
// const requireComponent = require.context("../components", true, /\.vue$/);
// requireComponent.keys().forEach(fileName => {
//   // 获取组件配置
//   const componentConfig = requireComponent(fileName);
//   // 剥去文件名开头的 `./` 和`.vue`结尾的扩展名
//   const componentName = fileName.match(/[^/](?=\.[^.]+$)/g).shift().replace(/([A-Z])/g, s1 => `-${s1.toLowerCase()}`);
//   // 全局注册组件
//   Vue.component(componentName.replace(/\//, "-"), componentConfig.default || componentConfig);
// });
